<template>
  <NavbarCta>
    <UIButton v-if="isLink && href" tag="a" variant="success" :href="href">
      {{ label }}
    </UIButton>

    <UIButton v-else variant="success" @click="show()">
      {{ label }}
    </UIButton>
  </NavbarCta>
</template>

<script lang="ts" setup>
import UIButton from "@/components/UI/UIButton.vue";
import { useDialog } from "@/components/UI/dialog/useDialog";
import NavbarCta from "@/components/navbar/NavbarCta.vue";
import { ProductTrialDialogId } from "./ProductTrialDialog.vue";

type Props = {
  isLink?: boolean;
  href?: string;
  label: string;
};

defineProps<Props>();
const { show } = useDialog(ProductTrialDialogId);
</script>
